// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3u271","author":"Table_author__3d1NG","authorImage":"Table_authorImage__2im7v","unreadRow":"Table_unreadRow__22hZn"};